import React from 'react';

import marketplace from 'cfg/marketplace.json';
import { CONTENT_LINK_ACTION_PARSE_RE } from 'common/regex';
import { onEvent } from 'helpers/EventHelpers';
import { trackEvent, trackLegacyEvent } from 'helpers/analytics';
import { makeOpenLiveChat } from 'helpers/ClientUtils';

/**
* Returns an object with Site-ops defined bgcolor attribute
* which will be set on the component as the inline 'style' property
*/
export function setInlineBackgroundColor(bgcolor) {
  if (bgcolor) {
    return { background: bgcolor };
  }
  return null;
}

/**
* Returns an object with Site-ops defined textcolor as the color attribute
* which will be set on the component as the inline 'style' property
*/
export function setInlineTextColor(textcolor) {
  if (textcolor) {
    return { color: textcolor };
  }
  return null;
}

/**
* Returns an object with Site-ops defined textcolor as the color and border-color attributes
* which will be set on the component as the inline 'style' property
*/
export function setInlineTextAndBorderColor(textcolor) {
  if (textcolor) {
    return { color: textcolor, borderColor: textcolor };
  }
  return null;
}

/**
* Returns an object with Site-ops defined textcolor as the color and border-bottom color attributes
* which will be set on the component as the inline 'style' property
*/
export function setInlineTextAndBorderBottomColor(textcolor) {
  if (textcolor) {
    return { color: textcolor, borderBottom: `1px solid ${textcolor}` };
  }
  return null;
}

/**
* Create or select event value for ProductGrid/MelodyCurated components
*/
export function makeProductAnalyticsEventValue(gae, productId, styleId, productName, name) {
  if (gae) {
    return gae;
  } else if (productId) {
    return `product-${productId}${styleId ? `-style-${styleId}` : ''}`;
  } else {
    return productName || name;
  }
}

/**
* Checks for Symphony <a> links including data-application-action attributes,
* with meta-data and/or instructions to render them.
*
* For example, <a data-application-action="livechat-popup" ... ></a>
* instructs Marty to open the link in a popup window.
*/
export function setupLandingEventWatcher(landingComponent, doOpenLiveChat) {
  const { chatWindowName } = marketplace;
  doOpenLiveChat = doOpenLiveChat || makeOpenLiveChat(chatWindowName);
  onEvent(document.body, 'click', e => {
    const { target } = e;
    if (target.tagName === 'A') {
      const contentApplicationAction = target.getAttribute('data-application-action') || '';
      const [ , actionName ] = contentApplicationAction.match(CONTENT_LINK_ACTION_PARSE_RE) || [];
      if (actionName === 'livechat-popup') {
        doOpenLiveChat(e);
        trackEvent('TE_PV_LANDINGPAGE', 'Live Help');
        trackLegacyEvent('Main-Nav', 'CustomerService', 'Live-Help');
      }
    }
  }, null, landingComponent);
}

/**
 * Landing and Brand send in the slotIndex;
 * > 1 it's the first 2 slots on the page & will not lazyload
 * The rest of the slots on the page will be true & will lazyload
 */
export function shouldLazyLoad(slotIndex) {
  return slotIndex > 1;
}

export const makeComponentHeading = ({ heading, className }) => heading && <h2 className={className}>{heading}</h2>;
